// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================================================
   Whiteboard.css
   Styles for WhiteboardPage and all sub-components (.wb-*)
   ============================================================================= */

/* ── Page shell ──────────────────────────────────────────────────────────────── */
.wb-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  background: var(--bg-primary, #f4f4f5);
}

/* ── Board selector bar ───────────────────────────────────────────────────────── */
.wb-board-bar {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  background: var(--bg-secondary, #fff);
  border-bottom: 1px solid var(--border-color, #e4e4e7);
  flex-shrink: 0;
  overflow-x: auto;
  scrollbar-width: none;
}
.wb-board-bar::-webkit-scrollbar { display: none; }

.wb-board-tab {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 6px 14px;
  border-radius: 20px;
  border: 1.5px solid var(--border-color, #e4e4e7);
  background: var(--bg-primary, #f4f4f5);
  color: var(--text-secondary, #71717a);
  font-size: 0.82rem;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.18s;
  flex-shrink: 0;
}
.wb-board-tab:hover {
  border-color: var(--accent, #2563eb);
  color: var(--accent, #2563eb);
  background: var(--bg-secondary, #fff);
}
.wb-board-tab.active {
  background: var(--accent, #2563eb);
  border-color: var(--accent, #2563eb);
  color: #fff;
  font-weight: 600;
}
.wb-board-tab .wb-board-tab-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}
.wb-board-tab.active .wb-board-tab-dot {
  background: rgba(255,255,255,0.7);
}
.wb-board-tab-count {
  font-size: 0.7rem;
  opacity: 0.75;
}

/* Board bar divider */
.wb-board-bar-divider {
  width: 1px;
  height: 22px;
  background: var(--border-color, #e4e4e7);
  flex-shrink: 0;
  margin: 0 4px;
}

/* Board bar action buttons */
.wb-board-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 7px;
  border: 1.5px solid var(--border-color, #e4e4e7);
  background: var(--bg-secondary, #fff);
  color: var(--text-secondary, #71717a);
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: all 0.18s;
}
.wb-board-action-btn:hover {
  border-color: var(--accent, #2563eb);
  color: var(--accent, #2563eb);
}
.wb-board-action-btn.wb-save-btn.has-dirty:hover {
  background: var(--accent, #2563eb);
  color: #fff;
  border-color: var(--accent, #2563eb);
}
.wb-board-action-btn.wb-save-btn.has-dirty {
  border-color: var(--accent, #2563eb);
  color: var(--accent, #2563eb);
  background: rgba(37,99,235,0.07);
}
.wb-board-action-btn.wb-new-board-btn:hover {
  background: var(--accent, #2563eb);
  color: #fff;
  border-color: var(--accent, #2563eb);
}

/* Inline new-board input */
.wb-new-board-input-wrap {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}
.wb-new-board-input {
  padding: 5px 10px;
  border: 1.5px solid var(--accent, #2563eb);
  border-radius: 7px;
  font-size: 0.82rem;
  background: var(--bg-secondary, #fff);
  color: var(--text-primary, #18181b);
  outline: none;
  width: 170px;
  transition: box-shadow 0.15s;
}
.wb-new-board-input:focus {
  box-shadow: 0 0 0 3px rgba(37,99,235,0.12);
}
.wb-new-board-confirm-btn {
  padding: 5px 10px;
  border-radius: 6px;
  border: none;
  background: var(--accent, #2563eb);
  color: #fff;
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s;
}
.wb-new-board-confirm-btn:hover { opacity: 0.85; }
.wb-new-board-cancel-btn {
  padding: 5px 8px;
  border-radius: 6px;
  border: 1px solid var(--border-color, #e4e4e7);
  background: none;
  color: var(--text-secondary);
  font-size: 0.78rem;
  cursor: pointer;
}

/* ── Main workspace (sidebar + canvas) ──────────────────────────────────────── */
.wb-workspace {
  display: grid;
  grid-template-columns: 280px 1fr;
  /* Fixed height so ReactFlow gets a real pixel height — same pattern as cdp-split */
  height: calc(100vh - 120px);
  min-height: 500px;
  overflow: hidden;
}
@media (max-width: 860px) {
  .wb-workspace {
    grid-template-columns: 1fr;
    height: auto;
    min-height: unset;
  }
}

/* ── Left sidebar ─────────────────────────────────────────────────────────────── */
.wb-sidebar {
  display: flex;
  flex-direction: column;
  background: var(--bg-secondary, #fff);
  border-right: 1px solid var(--border-color, #e4e4e7);
  overflow: hidden;
  height: 100%;
}

/* Board meta header */
.wb-board-meta {
  padding: 14px 16px;
  border-bottom: 1px solid var(--border-color, #e4e4e7);
  flex-shrink: 0;
}
.wb-board-meta-name {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary, #18181b);
  margin: 0 0 6px 0;
  display: flex;
  align-items: center;
  gap: 8px;
}
.wb-board-color-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}
.wb-board-meta-stats {
  display: flex;
  gap: 12px;
  font-size: 0.75rem;
  color: var(--text-secondary);
}
.wb-board-meta-stat {
  display: flex;
  align-items: center;
  gap: 4px;
}
.wb-board-delete-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin-top: 10px;
  padding: 4px 10px;
  border-radius: 5px;
  border: 1px solid rgba(239,68,68,0.3);
  background: none;
  color: #ef4444;
  font-size: 0.75rem;
  cursor: pointer;
  transition: all 0.15s;
}
.wb-board-delete-btn:hover {
  background: rgba(239,68,68,0.08);
  border-color: #ef4444;
}

/* Sidebar section title */
.wb-sidebar-section {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
}
.wb-sidebar-section + .wb-sidebar-section {
  border-top: 1px solid var(--border-color, #e4e4e7);
}
.wb-sidebar-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  flex-shrink: 0;
}
.wb-sidebar-section-title {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--text-secondary);
  display: flex;
  align-items: center;
  gap: 6px;
}
.wb-sidebar-section-count {
  font-size: 0.7rem;
  background: var(--bg-tertiary, #f4f4f5);
  padding: 1px 7px;
  border-radius: 99px;
  color: var(--text-secondary);
}

/* Connection filter */
.wb-conn-filter-row {
  display: flex;
  gap: 4px;
  padding: 0 12px 10px;
  flex-wrap: wrap;
  flex-shrink: 0;
}
.wb-conn-filter-btn {
  padding: 3px 9px;
  border-radius: 99px;
  border: 1px solid var(--border-color, #e4e4e7);
  background: none;
  font-size: 0.7rem;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.15s;
}
.wb-conn-filter-btn.active {
  background: var(--accent, #2563eb);
  border-color: var(--accent, #2563eb);
  color: #fff;
}

/* Scrollable list areas */
.wb-sidebar-list {
  overflow-y: auto;
  flex: 1 1;
  padding: 4px 8px 12px;
}

/* Connection row */
.wb-conn-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 8px;
  border-radius: 7px;
  cursor: default;
  transition: background 0.13s;
}
.wb-conn-row:hover { background: var(--bg-tertiary, #f4f4f5); }
.wb-conn-type-chip {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.62rem;
  font-weight: 700;
  color: #fff;
  white-space: nowrap;
  flex-shrink: 0;
  text-transform: uppercase;
}
.wb-conn-names {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
}
.wb-conn-label {
  font-size: 0.78rem;
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.wb-conn-pair {
  font-size: 0.7rem;
  color: var(--text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.wb-conn-confidence {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 3px;
  flex-shrink: 0;
}
.wb-conf-bar {
  width: 40px;
  height: 3px;
  background: var(--border-color, #e4e4e7);
  border-radius: 2px;
  overflow: hidden;
}
.wb-conf-fill { height: 100%; border-radius: 2px; }
.wb-conf-high { background: #10b981; }
.wb-conf-mid  { background: #f59e0b; }
.wb-conf-low  { background: #94a3b8; }
.wb-conf-label {
  font-size: 0.65rem;
  color: var(--text-secondary);
  font-weight: 600;
}
.wb-conn-dismiss-btn {
  background: none;
  border: none;
  color: var(--text-secondary);
  cursor: pointer;
  padding: 3px 5px;
  border-radius: 4px;
  font-size: 0.72rem;
  opacity: 0.5;
  transition: opacity 0.15s, color 0.15s;
  flex-shrink: 0;
}
.wb-conn-row:hover .wb-conn-dismiss-btn { opacity: 1; }
.wb-conn-dismiss-btn:hover { color: #ef4444; }

/* Item row in sidebar */
.wb-item-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  border-radius: 7px;
  cursor: pointer;
  transition: background 0.13s;
}
.wb-item-row:hover { background: var(--bg-tertiary, #f4f4f5); }
.wb-item-row.selected { background: rgba(37,99,235,0.08); }
.wb-item-type-chip {
  display: inline-block;
  padding: 2px 7px;
  border-radius: 4px;
  font-size: 0.62rem;
  font-weight: 700;
  color: #fff;
  white-space: nowrap;
  flex-shrink: 0;
  text-transform: uppercase;
}
.wb-item-title {
  flex: 1 1;
  font-size: 0.82rem;
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.wb-item-remove-btn {
  background: none;
  border: none;
  color: var(--text-secondary);
  cursor: pointer;
  padding: 3px 5px;
  border-radius: 4px;
  font-size: 0.72rem;
  opacity: 0;
  transition: opacity 0.15s, color 0.15s;
  flex-shrink: 0;
}
.wb-item-row:hover .wb-item-remove-btn { opacity: 1; }
.wb-item-remove-btn:hover { color: #ef4444; }

/* ── Canvas area ──────────────────────────────────────────────────────────────── */
.wb-canvas-wrap {
  position: relative;
  height: 100%;
  min-height: 500px;
  background: var(--bg-primary, #f4f4f5);
  overflow: hidden;
}

/* React Flow full coverage */
.wb-canvas-wrap .react-flow,
.wb-canvas-wrap .react-flow__renderer,
.wb-canvas-wrap .react-flow__container {
  width: 100%;
  height: 100%;
}

/* ── Empty / Loading / Error states ──────────────────────────────────────────── */
.wb-state-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 14px;
  color: var(--text-secondary);
  padding: 48px;
  text-align: center;
}
.wb-state-icon {
  font-size: 3rem;
  opacity: 0.35;
}
.wb-state-center h3 {
  margin: 0;
  font-size: 1.05rem;
  color: var(--text-primary);
  font-weight: 600;
}
.wb-state-center p {
  margin: 0;
  font-size: 0.88rem;
  max-width: 360px;
  line-height: 1.6;
}
.wb-spinner {
  width: 36px;
  height: 36px;
  border: 3px solid var(--border-color, #e4e4e7);
  border-top-color: var(--accent, #2563eb);
  border-radius: 50%;
  animation: wb-spin 1s linear infinite;
}
@keyframes wb-spin { to { transform: rotate(360deg); } }

/* Empty canvas overlay */
.wb-canvas-empty-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: var(--text-secondary);
  pointer-events: none;
}
.wb-canvas-empty-overlay i { font-size: 3rem; opacity: 0.2; }
.wb-canvas-empty-overlay p { font-size: 0.9rem; opacity: 0.5; margin: 0; }

/* No boards state */
.wb-no-boards {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 16px;
  color: var(--text-secondary);
  padding: 48px;
  text-align: center;
}
.wb-no-boards i { font-size: 4rem; opacity: 0.25; }
.wb-no-boards h3 { margin: 0; font-size: 1.1rem; color: var(--text-primary); }
.wb-no-boards p { margin: 0; font-size: 0.9rem; max-width: 340px; line-height: 1.6; }
.wb-create-first-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: var(--accent, #2563eb);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s;
}
.wb-create-first-btn:hover { opacity: 0.87; }

/* ── Item Detail Drawer ──────────────────────────────────────────────────────── */
.wb-item-drawer {
  position: absolute;
  top: 0;
  right: 0;
  width: min(340px, 100%);
  height: 100%;
  background: var(--bg-secondary, #fff);
  border-left: 1px solid var(--border-color, #e4e4e7);
  border-radius: 0 0 0 0;
  overflow-y: auto;
  z-index: 20;
  display: flex;
  flex-direction: column;
  box-shadow: -4px 0 20px rgba(0,0,0,0.09);
  animation: wb-drawer-in 0.18s ease;
}
@keyframes wb-drawer-in {
  from { transform: translateX(30px); opacity: 0; }
  to   { transform: translateX(0);    opacity: 1; }
}

.wb-drawer-header {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 16px;
  border-bottom: 1px solid var(--border-color, #e4e4e7);
  flex-shrink: 0;
}
.wb-drawer-title-block { flex: 1 1; min-width: 0; }
.wb-drawer-type-chip {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.65rem;
  font-weight: 700;
  color: #fff;
  text-transform: uppercase;
  margin-bottom: 6px;
}
.wb-drawer-title {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--text-primary);
  line-height: 1.35;
  word-break: break-word;
}
.wb-drawer-close-btn {
  background: none;
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 6px;
  padding: 5px 9px;
  cursor: pointer;
  color: var(--text-secondary);
  font-size: 0.85rem;
  flex-shrink: 0;
  transition: all 0.15s;
}
.wb-drawer-close-btn:hover { background: #ef4444; color: #fff; border-color: #ef4444; }

.wb-drawer-section {
  padding: 14px 16px;
  border-bottom: 1px solid var(--border-color, #e4e4e7);
}
.wb-drawer-section:last-child { border-bottom: none; }
.wb-drawer-section-label {
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--text-secondary);
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
  gap: 6px;
}

/* Tags */
.wb-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}
.wb-tag {
  background: rgba(37,99,235,0.09);
  color: var(--accent, #2563eb);
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 500;
}

/* Content / annotation */
.wb-drawer-content-text {
  font-size: 0.85rem;
  color: var(--text-primary);
  line-height: 1.6;
  margin: 0;
  white-space: pre-wrap;
}

/* Metadata table */
.wb-meta-table {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.wb-meta-row {
  display: flex;
  gap: 8px;
  font-size: 0.8rem;
  align-items: flex-start;
}
.wb-meta-key {
  color: var(--text-secondary);
  font-weight: 600;
  min-width: 80px;
  flex-shrink: 0;
  padding-top: 2px;
}
.wb-meta-val {
  color: var(--text-primary);
  word-break: break-word;
  flex: 1 1;
}

/* Null / empty value */
.wb-meta-null {
  color: var(--text-secondary);
  font-style: italic;
  opacity: 0.65;
}

/* Boolean badge */
.wb-meta-bool {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 4px;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
}
.wb-meta-bool-yes { background: rgba(16,185,129,0.15); color: #15803d; }
.wb-meta-bool-no  { background: rgba(148,163,184,0.2);  color: #64748b; }

/* Array of primitives — pill list */
.wb-meta-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  flex: 1 1;
}
.wb-meta-tag {
  display: inline-block;
  padding: 2px 7px;
  background: var(--bg-tertiary, #f4f4f5);
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 4px;
  font-size: 0.75rem;
  color: var(--text-primary);
}

/* Flat object — nested key-value sub-table */
.wb-meta-sub-table {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1 1;
  background: var(--bg-tertiary, #f4f4f5);
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 5px;
  padding: 6px 8px;
}
.wb-meta-sub-row {
  display: flex;
  gap: 6px;
  font-size: 0.75rem;
}
.wb-meta-sub-key {
  color: var(--text-secondary);
  font-weight: 600;
  min-width: 70px;
  flex-shrink: 0;
}
.wb-meta-sub-val {
  color: var(--text-primary);
  word-break: break-word;
  flex: 1 1;
}

/* Complex / nested object — formatted JSON block */
.wb-meta-json {
  flex: 1 1;
  margin: 0;
  padding: 7px 10px;
  background: var(--bg-tertiary, #f4f4f5);
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 5px;
  font-family: ui-monospace, 'Cascadia Code', monospace;
  font-size: 0.72rem;
  color: var(--text-secondary);
  white-space: pre-wrap;
  word-break: break-word;
  overflow-x: auto;
  line-height: 1.55;
  max-height: 180px;
}

/* Connections in drawer */
.wb-drawer-conn-row {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 5px 0;
  border-bottom: 1px solid var(--border-color, #f4f4f5);
  font-size: 0.8rem;
}
.wb-drawer-conn-row:last-child { border-bottom: none; }
.wb-drawer-conn-name { flex: 1 1; color: var(--text-primary); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.wb-drawer-conf {
  font-size: 0.7rem;
  font-weight: 600;
  padding: 1px 5px;
  border-radius: 4px;
  white-space: nowrap;
}

/* ── Confirm dialog overlay ─────────────────────────────────────────────────── */
.wb-confirm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.wb-confirm-box {
  background: var(--bg-secondary, #fff);
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 12px;
  padding: 28px 32px;
  max-width: 380px;
  width: 90%;
  box-shadow: 0 20px 60px rgba(0,0,0,0.2);
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.wb-confirm-box h4 {
  margin: 0;
  font-size: 1rem;
  color: var(--text-primary);
}
.wb-confirm-box p {
  margin: 0;
  font-size: 0.88rem;
  color: var(--text-secondary);
  line-height: 1.55;
}
.wb-confirm-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}
.wb-confirm-cancel-btn {
  padding: 8px 16px;
  border-radius: 7px;
  border: 1px solid var(--border-color, #e4e4e7);
  background: none;
  color: var(--text-secondary);
  font-size: 0.88rem;
  cursor: pointer;
}
.wb-confirm-delete-btn {
  padding: 8px 16px;
  border-radius: 7px;
  border: none;
  background: #ef4444;
  color: #fff;
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s;
}
.wb-confirm-delete-btn:hover { opacity: 0.87; }

/* ── Toast notification ─────────────────────────────────────────────────────── */
.wb-toast {
  position: fixed;
  bottom: 24px;
  right: 24px;
  background: #1e293b;
  color: #fff;
  padding: 10px 18px;
  border-radius: 8px;
  font-size: 0.85rem;
  box-shadow: 0 8px 24px rgba(0,0,0,0.25);
  z-index: 2000;
  display: flex;
  align-items: center;
  gap: 8px;
  animation: wb-toast-in 0.2s ease;
}
.wb-toast.success { background: #15803d; }
.wb-toast.error   { background: #b91c1c; }
@keyframes wb-toast-in {
  from { transform: translateY(12px); opacity: 0; }
  to   { transform: translateY(0);    opacity: 1; }
}

/* ── Board Insights Panel (.wb-insights-*) ──────────────────────────────────── */
.wb-insights-panel {
  position: absolute;
  top: 0;
  right: 0;
  width: min(460px, 100%);
  height: 100%;
  background: var(--bg-secondary, #fff);
  border-left: 1px solid var(--border-color, #e4e4e7);
  overflow-y: auto;
  z-index: 25;
  display: flex;
  flex-direction: column;
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.12);
  animation: wb-drawer-in 0.18s ease;
}

.wb-insights-header {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 16px;
  border-bottom: 1px solid var(--border-color, #e4e4e7);
  flex-shrink: 0;
  background: linear-gradient(135deg, rgba(37, 99, 235, 0.05) 0%, rgba(99, 102, 241, 0.05) 100%);
}
.wb-insights-brain-icon {
  font-size: 1.4rem;
  color: var(--accent, #2563eb);
  flex-shrink: 0;
  margin-top: 2px;
}
.wb-insights-header-left {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  flex: 1 1;
  min-width: 0;
}
.wb-insights-title {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary, #18181b);
}
.wb-insights-timestamp {
  display: block;
  font-size: 0.72rem;
  color: var(--text-secondary, #71717a);
  margin-top: 3px;
}
.wb-insights-header-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}
.wb-insights-regen-btn {
  background: none;
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 6px;
  padding: 5px 9px;
  cursor: pointer;
  color: var(--text-secondary, #71717a);
  font-size: 0.8rem;
  transition: all 0.15s;
}
.wb-insights-regen-btn:hover:not(:disabled) { border-color: var(--accent, #2563eb); color: var(--accent, #2563eb); }
.wb-insights-regen-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.wb-insights-close-btn {
  background: none;
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 6px;
  padding: 5px 9px;
  cursor: pointer;
  color: var(--text-secondary, #71717a);
  font-size: 0.85rem;
  transition: all 0.15s;
}
.wb-insights-close-btn:hover { background: #ef4444; color: #fff; border-color: #ef4444; }

.wb-insights-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  flex: 1 1;
  color: var(--text-secondary, #71717a);
  padding: 48px;
  text-align: center;
}
.wb-insights-loading p { margin: 0; font-size: 0.9rem; }

.wb-insights-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex: 1 1;
  padding: 40px;
  color: #dc2626;
  text-align: center;
}
.wb-insights-error i { font-size: 2rem; opacity: 0.7; }
.wb-insights-error p { margin: 0; font-size: 0.88rem; }
.wb-insights-error button {
  padding: 7px 16px;
  border-radius: 6px;
  border: 1px solid rgba(239, 68, 68, 0.4);
  background: none;
  color: #dc2626;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.15s;
}
.wb-insights-error button:hover { background: rgba(239, 68, 68, 0.08); }

.wb-insights-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: var(--bg-primary, #f4f4f5);
}

.wb-insights-section {
  background: var(--bg-secondary, #fff);
  border: 1px solid var(--border-color, #e4e4e7);
  border-radius: 10px;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.wb-insights-section-title {
  margin: 0;
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--text-secondary, #71717a);
  display: flex;
  align-items: center;
  gap: 6px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--border-color, #e4e4e7);
}
.wb-insights-section-title i { color: var(--accent, #2563eb); }

.wb-insights-overview {
  margin: 0;
  font-size: 0.875rem;
  color: var(--text-primary, #18181b);
  line-height: 1.65;
  font-style: italic;
}

.wb-insights-group { display: flex; flex-direction: column; gap: 6px; }
.wb-insights-group-label {
  margin: 0;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--text-secondary, #71717a);
  display: flex;
  align-items: center;
  gap: 5px;
}

.wb-insights-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.wb-insights-list-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 0.83rem;
  color: var(--text-primary, #18181b);
  line-height: 1.5;
  padding: 6px 10px;
  border-radius: 5px;
}
.wb-insights-list-item::before {
  content: '';
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--border-color, #e4e4e7);
  flex-shrink: 0;
  margin-top: 5px;
}
.wb-insights-theme          { background: rgba(37, 99, 235, 0.05);  }
.wb-insights-theme::before  { background: var(--accent, #2563eb); }
.wb-insights-signal         { background: rgba(8, 145, 178, 0.05); }
.wb-insights-signal::before { background: #0891b2; }
.wb-insights-anomaly        { background: rgba(245, 158, 11, 0.07); }
.wb-insights-anomaly::before{ background: #f59e0b; }
.wb-insights-relationship        { background: rgba(99, 102, 241, 0.05); }
.wb-insights-relationship::before{ background: #6366f1; }
.wb-insights-hub            { background: rgba(245, 158, 11, 0.05); }
.wb-insights-hub::before    { background: #f59e0b; }
.wb-insights-lead           { background: rgba(16, 185, 129, 0.05); }
.wb-insights-lead::before   { background: #10b981; }

.wb-insights-recommendation {
  background: rgba(37, 99, 235, 0.05);
  border: 1px solid rgba(37, 99, 235, 0.12);
  padding: 8px 10px;
  gap: 10px;
}
.wb-insights-recommendation::before { display: none; }
.wb-insights-rec-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  min-width: 20px;
  background: var(--accent, #2563eb);
  color: #fff;
  border-radius: 50%;
  font-size: 0.65rem;
  font-weight: 700;
  flex-shrink: 0;
}

.wb-insights-footer-row {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 4px;
}
.wb-insights-footer-meta {
  margin: 0;
  font-size: 0.72rem;
  color: var(--text-secondary, #71717a);
  display: flex;
  align-items: center;
  gap: 5px;
  opacity: 0.65;
}

/* Insights button active state */
.wb-board-action-btn.wb-insights-btn.active {
  background: rgba(37, 99, 235, 0.08);
  border-color: var(--accent, #2563eb);
  color: var(--accent, #2563eb);
}
.wb-board-action-btn.wb-insights-btn:hover:not(:disabled) {
  background: var(--accent, #2563eb);
  color: #fff;
  border-color: var(--accent, #2563eb);
}
.wb-board-action-btn.wb-insights-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* ── Dark theme overrides ───────────────────────────────────────────────────── */
[data-theme="dark"] {
  .wb-board-bar { background: var(--bg-secondary); }
  .wb-board-tab { background: var(--bg-tertiary); }
  .wb-board-tab:hover { background: var(--bg-secondary); }
  .wb-board-action-btn { background: var(--bg-secondary); }
  .wb-new-board-input { background: var(--bg-secondary); }
  .wb-sidebar { background: var(--bg-secondary); }
  .wb-item-drawer { background: var(--bg-secondary); box-shadow: -4px 0 20px rgba(0,0,0,0.45); }
  .wb-conn-row:hover { background: var(--bg-tertiary); }
  .wb-item-row:hover { background: var(--bg-tertiary); }
  .wb-item-row.selected { background: rgba(59,130,246,0.12); }
  .wb-confirm-overlay { background: rgba(0,0,0,0.65); }
  .wb-confirm-box { background: var(--bg-secondary); box-shadow: 0 20px 60px rgba(0,0,0,0.6); }
  .wb-toast { background: #334155; }
  .wb-toast.success { background: #166534; }
  .wb-toast.error   { background: #991b1b; }
  .wb-insights-panel { box-shadow: -4px 0 24px rgba(0,0,0,.5); }
  .wb-insights-header { background: linear-gradient(135deg, rgba(37,99,235,.1) 0%, rgba(99,102,241,.1) 100%); }
  .wb-insights-body { background: var(--bg-primary); }
  .wb-insights-section { background: var(--bg-secondary); border-color: var(--border-color); }
  .wb-insights-section-title { border-bottom-color: var(--border-color); }
}

/* ═══════════════════════════════════════════════════════════════════════════
   PIN TO BOARD POPOVER
   ═══════════════════════════════════════════════════════════════════════════ */

.wb-pin-popover {
  width: 272px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.18), 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  font-family: inherit;
  animation: wb-pin-in 0.14s ease-out;
}

@keyframes wb-pin-in {
  from { opacity: 0; transform: translateY(-4px) scale(0.97); }
  to   { opacity: 1; transform: translateY(0)    scale(1); }
}

/* Header */
.wb-pin-popover-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 11px 14px 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
  background: #f8fafc;
}

.wb-pin-icon {
  color: #f59e0b;
  font-size: 0.85rem;
  flex-shrink: 0;
}

.wb-pin-popover-label {
  flex: 1 1;
  font-size: 0.8rem;
  font-weight: 600;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.wb-pin-popover-close {
  background: none;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  padding: 2px 4px;
  border-radius: 4px;
  font-size: 0.78rem;
  line-height: 1;
  flex-shrink: 0;
  transition: color 0.15s, background 0.15s;
}
.wb-pin-popover-close:hover { color: #475569; background: rgba(0,0,0,0.06); }

/* Feedback bar */
.wb-pin-feedback {
  font-size: 0.78rem;
  font-weight: 500;
  padding: 7px 14px;
  text-align: center;
}
.wb-pin-feedback-success { background: rgba(16,185,129,0.1); color: #065f46; }
.wb-pin-feedback-warn    { background: rgba(245,158,11,0.1);  color: #92400e; }
.wb-pin-feedback-error   { background: rgba(239,68,68,0.1);   color: #991b1b; }

/* Board list */
.wb-pin-board-list {
  max-height: 220px;
  overflow-y: auto;
  padding: 4px 0;
}

.wb-pin-no-boards {
  font-size: 0.78rem;
  color: #94a3b8;
  text-align: center;
  padding: 16px 14px;
  margin: 0;
}

.wb-pin-board-row {
  display: flex;
  align-items: center;
  gap: 9px;
  width: 100%;
  padding: 8px 14px;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  transition: background 0.12s;
}
.wb-pin-board-row:hover:not(:disabled) { background: rgba(99,102,241,0.07); }
.wb-pin-board-row:disabled { opacity: 0.55; cursor: not-allowed; }

.wb-pin-board-dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  flex-shrink: 0;
}

.wb-pin-board-name {
  flex: 1 1;
  font-size: 0.83rem;
  font-weight: 500;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.wb-pin-board-count {
  font-size: 0.72rem;
  color: #94a3b8;
  background: #f1f5f9;
  border-radius: 10px;
  padding: 1px 7px;
  flex-shrink: 0;
}

.wb-pin-board-spinner {
  color: #6366f1;
  font-size: 0.78rem;
}

/* Footer */
.wb-pin-popover-footer {
  border-top: 1px solid rgba(0,0,0,0.07);
  padding: 8px 10px;
  background: #f8fafc;
}

.wb-pin-new-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  padding: 7px 10px;
  background: none;
  border: 1.5px dashed #cbd5e1;
  border-radius: 7px;
  color: #64748b;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  transition: border-color 0.15s, color 0.15s, background 0.15s;
}
.wb-pin-new-btn:hover { border-color: #6366f1; color: #6366f1; background: rgba(99,102,241,0.04); }

.wb-pin-new-row {
  display: flex;
  gap: 6px;
}

.wb-pin-new-input {
  flex: 1 1;
  padding: 6px 10px;
  border: 1.5px solid #e2e8f0;
  border-radius: 7px;
  font-size: 0.8rem;
  color: #1e293b;
  background: #fff;
  outline: none;
  transition: border-color 0.15s;
}
.wb-pin-new-input:focus { border-color: #6366f1; }

.wb-pin-new-confirm {
  padding: 6px 11px;
  background: #6366f1;
  color: #fff;
  border: none;
  border-radius: 7px;
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s;
}
.wb-pin-new-confirm:hover:not(:disabled) { background: #4f46e5; }
.wb-pin-new-confirm:disabled { opacity: 0.55; cursor: not-allowed; }

/* ═══════════════════════════════════════════════════════════════════════════
   GENERIC PIN BUTTON — table rows (IntelligenceTable, NewsTable, PdfTable)
   ═══════════════════════════════════════════════════════════════════════════ */

.pin-btn {
  background: none;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 5px;
  font-size: 0.85rem;
  line-height: 1;
  transition: color 0.15s, background 0.15s;
  vertical-align: middle;
}
.pin-btn:hover { color: #f59e0b; background: rgba(245,158,11,0.1); }

.actions-cell {
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}

/* ═══════════════════════════════════════════════════════════════════════════
   OS PIN BUTTON — OmniSearch NodeDetailSidebar
   ═══════════════════════════════════════════════════════════════════════════ */

.os-pin-btn {
  display: flex;
  align-items: center;
  gap: 7px;
  width: 100%;
  padding: 9px 14px;
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s, transform 0.12s;
  letter-spacing: 0.01em;
}
.os-pin-btn:hover { opacity: 0.88; transform: translateY(-1px); }
.os-pin-btn:active { transform: translateY(0); }
.os-pin-btn i { font-size: 0.78rem; }

/* Dark mode overrides for pin popover */
@media (prefers-color-scheme: dark) {
  .wb-pin-popover { background: #1e293b; border-color: rgba(255,255,255,0.1); }
  .wb-pin-popover-header { background: #0f172a; border-bottom-color: rgba(255,255,255,0.07); }
  .wb-pin-popover-label { color: #f1f5f9; }
  .wb-pin-board-name { color: #e2e8f0; }
  .wb-pin-board-count { background: #334155; color: #94a3b8; }
  .wb-pin-popover-footer { background: #0f172a; border-top-color: rgba(255,255,255,0.07); }
  .wb-pin-new-input { background: #1e293b; border-color: #334155; color: #f1f5f9; }
  .wb-pin-board-row:hover:not(:disabled) { background: rgba(99,102,241,0.12); }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Whiteboard.css"],"names":[],"mappings":"AAAA;;;kFAGkF;;AAElF,mFAAmF;AACnF;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,sCAAsC;AACxC;;AAEA,oFAAoF;AACpF;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,qCAAqC;EACrC,qDAAqD;EACrD,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;AACA,mCAAmC,aAAa,EAAE;;AAElD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,gDAAgD;EAChD,sCAAsC;EACtC,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,qCAAqC;AACvC;AACA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,UAAU;EACV,YAAY;EACZ,wCAAwC;EACxC,cAAc;EACd,aAAa;AACf;;AAEA,6BAA6B;AAC7B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,gDAAgD;EAChD,qCAAqC;EACrC,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;AACA;EACE,kCAAkC;EAClC,WAAW;EACX,oCAAoC;AACtC;AACA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,gCAAgC;AAClC;AACA;EACE,kCAAkC;EAClC,WAAW;EACX,oCAAoC;AACtC;;AAEA,2BAA2B;AAC3B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,mCAAmC;EACnC,aAAa;EACb,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;AACA,kCAAkC,aAAa,EAAE;AACjD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,8CAA8C;EAC9C,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;AACjB;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,gCAAgC;EAChC,mFAAmF;EACnF,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE;IACE,0BAA0B;IAC1B,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA,oFAAoF;AACpF;EACE,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,oDAAoD;EACpD,gBAAgB;EAChB,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,qDAAqD;EACrD,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,kDAAkD;AACpD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,uCAAuC;EACvC,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,QAAQ;EACR,oBAAoB;EACpB,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,SAAO;EACP,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,4BAA4B;AAC9B;AACA,qBAAqB,uCAAuC,EAAE;AAC9D;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,WAAW;EACX,WAAW;EACX,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;AAClB;AACA,gBAAgB,YAAY,EAAE,kBAAkB,EAAE;AAClD,gBAAgB,mBAAmB,EAAE;AACrC,gBAAgB,mBAAmB,EAAE;AACrC,gBAAgB,mBAAmB,EAAE;AACrC;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,sCAAsC;EACtC,cAAc;AAChB;AACA,0CAA0C,UAAU,EAAE;AACtD,6BAA6B,cAAc,EAAE;;AAE7C,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,4BAA4B;AAC9B;AACA,qBAAqB,uCAAuC,EAAE;AAC9D,wBAAwB,gCAAgC,EAAE;AAC1D;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,SAAO;EACP,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,sCAAsC;EACtC,cAAc;AAChB;AACA,yCAAyC,UAAU,EAAE;AACrD,4BAA4B,cAAc,EAAE;;AAE5C,oFAAoF;AACpF;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;;;EAGE,WAAW;EACX,YAAY;AACd;;AAEA,mFAAmF;AACnF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,4BAA4B;EAC5B,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,aAAa;AACf;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,8CAA8C;EAC9C,wCAAwC;EACxC,kBAAkB;EAClB,qCAAqC;AACvC;AACA,qBAAqB,KAAK,yBAAyB,EAAE,EAAE;;AAEvD,yBAAyB;AACzB;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,4BAA4B;EAC5B,oBAAoB;AACtB;AACA,6BAA6B,eAAe,EAAE,YAAY,EAAE;AAC5D,6BAA6B,iBAAiB,EAAE,YAAY,EAAE,SAAS,EAAE;;AAEzE,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,4BAA4B;EAC5B,aAAa;EACb,kBAAkB;AACpB;AACA,kBAAkB,eAAe,EAAE,aAAa,EAAE;AAClD,mBAAmB,SAAS,EAAE,iBAAiB,EAAE,0BAA0B,EAAE;AAC7E,kBAAkB,SAAS,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACpF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;AACA,6BAA6B,aAAa,EAAE;;AAE5C,mFAAmF;AACnF;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,uBAAuB;EACvB,YAAY;EACZ,qCAAqC;EACrC,mDAAmD;EACnD,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,wCAAwC;EACxC,kCAAkC;AACpC;AACA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,OAAO,wBAAwB,KAAK,UAAU,EAAE;AAClD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,qDAAqD;EACrD,cAAc;AAChB;AACA,yBAAyB,SAAO,EAAE,YAAY,EAAE;AAChD;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;AACA,6BAA6B,mBAAmB,EAAE,WAAW,EAAE,qBAAqB,EAAE;;AAEtF;EACE,kBAAkB;EAClB,qDAAqD;AACvD;AACA,gCAAgC,mBAAmB,EAAE;AACrD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,4BAA4B;EAC5B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,SAAS;AACT;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,SAAS;EACT,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,SAAO;AACT;;AAEA,uBAAuB;AACvB;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA,oBAAoB,iCAAiC,EAAE,cAAc,EAAE;AACvE,oBAAoB,iCAAiC,GAAG,cAAc,EAAE;;AAExE,oCAAoC;AACpC;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,SAAO;AACT;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,uCAAuC;EACvC,8CAA8C;EAC9C,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,uCAAuC;EACvC,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,SAAO;AACT;;AAEA,mDAAmD;AACnD;EACE,SAAO;EACP,SAAS;EACT,iBAAiB;EACjB,uCAAuC;EACvC,8CAA8C;EAC9C,kBAAkB;EAClB,qDAAqD;EACrD,kBAAkB;EAClB,4BAA4B;EAC5B,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,qDAAqD;EACrD,iBAAiB;AACnB;AACA,iCAAiC,mBAAmB,EAAE;AACtD,uBAAuB,SAAO,EAAE,0BAA0B,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC5H;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,kFAAkF;AAClF;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,qCAAqC;EACrC,8CAA8C;EAC9C,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,uCAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,8CAA8C;EAC9C,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;AACA,+BAA+B,aAAa,EAAE;;AAE9C,kFAAkF;AAClF;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,uCAAuC;EACvC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;AAClC;AACA,oBAAoB,mBAAmB,EAAE;AACzC,oBAAoB,mBAAmB,EAAE;AACzC;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,OAAO,wBAAwB,KAAK,UAAU,EAAE;AAClD;;AAEA,kFAAkF;AAClF;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,uBAAuB;EACvB,YAAY;EACZ,qCAAqC;EACrC,mDAAmD;EACnD,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,qDAAqD;EACrD,cAAc;EACd,8FAA8F;AAChG;AACA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,SAAO;EACP,YAAY;AACd;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qCAAqC;EACrC,iBAAiB;EACjB,qBAAqB;AACvB;AACA,8CAA8C,oCAAoC,EAAE,6BAA6B,EAAE;AACnH,kCAAkC,YAAY,EAAE,mBAAmB,EAAE;AACrE;EACE,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qCAAqC;EACrC,kBAAkB;EAClB,qBAAqB;AACvB;AACA,+BAA+B,mBAAmB,EAAE,WAAW,EAAE,qBAAqB,EAAE;;AAExF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,SAAO;EACP,qCAAqC;EACrC,aAAa;EACb,kBAAkB;AACpB;AACA,yBAAyB,SAAS,EAAE,iBAAiB,EAAE;;AAEvD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,SAAO;EACP,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;AACA,uBAAuB,eAAe,EAAE,YAAY,EAAE;AACtD,uBAAuB,SAAS,EAAE,kBAAkB,EAAE;AACtD;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;AACA,kCAAkC,mCAAmC,EAAE;;AAEvE;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;EACrC,8CAA8C;EAC9C,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,qDAAqD;AACvD;AACA,+BAA+B,6BAA6B,EAAE;;AAE9D;EACE,SAAS;EACT,mBAAmB;EACnB,mCAAmC;EACnC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,qBAAqB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACtE;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wCAAwC;EACxC,cAAc;EACd,eAAe;AACjB;AACA,8BAA8B,mCAAmC,GAAG;AACpE,8BAA8B,kCAAkC,EAAE;AAClE,8BAA8B,mCAAmC,EAAE;AACnE,8BAA8B,mBAAmB,EAAE;AACnD,8BAA8B,oCAAoC,EAAE;AACpE,8BAA8B,mBAAmB,EAAE;AACnD,mCAAmC,oCAAoC,EAAE;AACzE,mCAAmC,mBAAmB,EAAE;AACxD,8BAA8B,oCAAoC,EAAE;AACpE,8BAA8B,mBAAmB,EAAE;AACnD,8BAA8B,oCAAoC,EAAE;AACpE,8BAA8B,mBAAmB,EAAE;;AAEnD;EACE,mCAAmC;EACnC,yCAAyC;EACzC,iBAAiB;EACjB,SAAS;AACX;AACA,sCAAsC,aAAa,EAAE;AACrD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kCAAkC;EAClC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;AACf;;AAEA,iCAAiC;AACjC;EACE,mCAAmC;EACnC,oCAAoC;EACpC,6BAA6B;AAC/B;AACA;EACE,kCAAkC;EAClC,WAAW;EACX,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,kFAAkF;AAClF;EACE,gBAAgB,+BAA+B,EAAE;EACjD,gBAAgB,8BAA8B,EAAE;EAChD,sBAAsB,+BAA+B,EAAE;EACvD,uBAAuB,+BAA+B,EAAE;EACxD,sBAAsB,+BAA+B,EAAE;EACvD,cAAc,+BAA+B,EAAE;EAC/C,kBAAkB,+BAA+B,EAAE,wCAAwC,EAAE;EAC7F,qBAAqB,8BAA8B,EAAE;EACrD,qBAAqB,8BAA8B,EAAE;EACrD,wBAAwB,iCAAiC,EAAE;EAC3D,sBAAsB,4BAA4B,EAAE;EACpD,kBAAkB,+BAA+B,EAAE,uCAAuC,EAAE;EAC5F,YAAY,mBAAmB,EAAE;EACjC,oBAAoB,mBAAmB,EAAE;EACzC,oBAAoB,mBAAmB,EAAE;EACzC,qBAAqB,sCAAsC,EAAE;EAC7D,sBAAsB,oFAAoF,EAAE;EAC5G,oBAAoB,6BAA6B,EAAE;EACnD,uBAAuB,+BAA+B,EAAE,iCAAiC,EAAE;EAC3F,6BAA6B,wCAAwC,EAAE;AACzE;;AAEA;;gFAEgF;;AAEhF;EACE,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,yEAAyE;EACzE,gBAAgB;EAChB,oBAAoB;EACpB,mCAAmC;AACrC;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,oCAAoC,EAAE;AAC3D;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,yCAAyC;AAC3C;AACA,8BAA8B,cAAc,EAAE,4BAA4B,EAAE;;AAE5E,iBAAiB;AACjB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA,2BAA2B,gCAAgC,EAAE,cAAc,EAAE;AAC7E,2BAA2B,gCAAgC,GAAG,cAAc,EAAE;AAC9E,2BAA2B,+BAA+B,IAAI,cAAc,EAAE;;AAE9E,eAAe;AACf;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;AACA,yCAAyC,iCAAiC,EAAE;AAC5E,6BAA6B,aAAa,EAAE,mBAAmB,EAAE;;AAEjE;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,sCAAsC;EACtC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,6DAA6D;AAC/D;AACA,wBAAwB,qBAAqB,EAAE,cAAc,EAAE,iCAAiC,EAAE;;AAElG;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,8BAA8B;AAChC;AACA,0BAA0B,qBAAqB,EAAE;;AAEjD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,4BAA4B;AAC9B;AACA,2CAA2C,mBAAmB,EAAE;AAChE,+BAA+B,aAAa,EAAE,mBAAmB,EAAE;;AAEnE;;gFAEgF;;AAEhF;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,yCAAyC;EACzC,sBAAsB;AACxB;AACA,iBAAiB,cAAc,EAAE,gCAAgC,EAAE;;AAEnE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;gFAEgF;;AAEhF;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,6DAA6D;EAC7D,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,0CAA0C;EAC1C,sBAAsB;AACxB;AACA,oBAAoB,aAAa,EAAE,2BAA2B,EAAE;AAChE,qBAAqB,wBAAwB,EAAE;AAC/C,gBAAgB,kBAAkB,EAAE;;AAEpC,wCAAwC;AACxC;EACE,kBAAkB,mBAAmB,EAAE,mCAAmC,EAAE;EAC5E,yBAAyB,mBAAmB,EAAE,2CAA2C,EAAE;EAC3F,wBAAwB,cAAc,EAAE;EACxC,qBAAqB,cAAc,EAAE;EACrC,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;EAC3D,yBAAyB,mBAAmB,EAAE,wCAAwC,EAAE;EACxF,oBAAoB,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;EAChF,yCAAyC,iCAAiC,EAAE;AAC9E","sourcesContent":["/* =============================================================================\n   Whiteboard.css\n   Styles for WhiteboardPage and all sub-components (.wb-*)\n   ============================================================================= */\n\n/* ── Page shell ──────────────────────────────────────────────────────────────── */\n.wb-page {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n  background: var(--bg-primary, #f4f4f5);\n}\n\n/* ── Board selector bar ───────────────────────────────────────────────────────── */\n.wb-board-bar {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 16px;\n  background: var(--bg-secondary, #fff);\n  border-bottom: 1px solid var(--border-color, #e4e4e7);\n  flex-shrink: 0;\n  overflow-x: auto;\n  scrollbar-width: none;\n}\n.wb-board-bar::-webkit-scrollbar { display: none; }\n\n.wb-board-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 6px 14px;\n  border-radius: 20px;\n  border: 1.5px solid var(--border-color, #e4e4e7);\n  background: var(--bg-primary, #f4f4f5);\n  color: var(--text-secondary, #71717a);\n  font-size: 0.82rem;\n  font-weight: 500;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: all 0.18s;\n  flex-shrink: 0;\n}\n.wb-board-tab:hover {\n  border-color: var(--accent, #2563eb);\n  color: var(--accent, #2563eb);\n  background: var(--bg-secondary, #fff);\n}\n.wb-board-tab.active {\n  background: var(--accent, #2563eb);\n  border-color: var(--accent, #2563eb);\n  color: #fff;\n  font-weight: 600;\n}\n.wb-board-tab .wb-board-tab-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n.wb-board-tab.active .wb-board-tab-dot {\n  background: rgba(255,255,255,0.7);\n}\n.wb-board-tab-count {\n  font-size: 0.7rem;\n  opacity: 0.75;\n}\n\n/* Board bar divider */\n.wb-board-bar-divider {\n  width: 1px;\n  height: 22px;\n  background: var(--border-color, #e4e4e7);\n  flex-shrink: 0;\n  margin: 0 4px;\n}\n\n/* Board bar action buttons */\n.wb-board-action-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border-radius: 7px;\n  border: 1.5px solid var(--border-color, #e4e4e7);\n  background: var(--bg-secondary, #fff);\n  color: var(--text-secondary, #71717a);\n  font-size: 0.8rem;\n  font-weight: 500;\n  cursor: pointer;\n  white-space: nowrap;\n  flex-shrink: 0;\n  transition: all 0.18s;\n}\n.wb-board-action-btn:hover {\n  border-color: var(--accent, #2563eb);\n  color: var(--accent, #2563eb);\n}\n.wb-board-action-btn.wb-save-btn.has-dirty:hover {\n  background: var(--accent, #2563eb);\n  color: #fff;\n  border-color: var(--accent, #2563eb);\n}\n.wb-board-action-btn.wb-save-btn.has-dirty {\n  border-color: var(--accent, #2563eb);\n  color: var(--accent, #2563eb);\n  background: rgba(37,99,235,0.07);\n}\n.wb-board-action-btn.wb-new-board-btn:hover {\n  background: var(--accent, #2563eb);\n  color: #fff;\n  border-color: var(--accent, #2563eb);\n}\n\n/* Inline new-board input */\n.wb-new-board-input-wrap {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n}\n.wb-new-board-input {\n  padding: 5px 10px;\n  border: 1.5px solid var(--accent, #2563eb);\n  border-radius: 7px;\n  font-size: 0.82rem;\n  background: var(--bg-secondary, #fff);\n  color: var(--text-primary, #18181b);\n  outline: none;\n  width: 170px;\n  transition: box-shadow 0.15s;\n}\n.wb-new-board-input:focus {\n  box-shadow: 0 0 0 3px rgba(37,99,235,0.12);\n}\n.wb-new-board-confirm-btn {\n  padding: 5px 10px;\n  border-radius: 6px;\n  border: none;\n  background: var(--accent, #2563eb);\n  color: #fff;\n  font-size: 0.78rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity 0.15s;\n}\n.wb-new-board-confirm-btn:hover { opacity: 0.85; }\n.wb-new-board-cancel-btn {\n  padding: 5px 8px;\n  border-radius: 6px;\n  border: 1px solid var(--border-color, #e4e4e7);\n  background: none;\n  color: var(--text-secondary);\n  font-size: 0.78rem;\n  cursor: pointer;\n}\n\n/* ── Main workspace (sidebar + canvas) ──────────────────────────────────────── */\n.wb-workspace {\n  display: grid;\n  grid-template-columns: 280px 1fr;\n  /* Fixed height so ReactFlow gets a real pixel height — same pattern as cdp-split */\n  height: calc(100vh - 120px);\n  min-height: 500px;\n  overflow: hidden;\n}\n@media (max-width: 860px) {\n  .wb-workspace {\n    grid-template-columns: 1fr;\n    height: auto;\n    min-height: unset;\n  }\n}\n\n/* ── Left sidebar ─────────────────────────────────────────────────────────────── */\n.wb-sidebar {\n  display: flex;\n  flex-direction: column;\n  background: var(--bg-secondary, #fff);\n  border-right: 1px solid var(--border-color, #e4e4e7);\n  overflow: hidden;\n  height: 100%;\n}\n\n/* Board meta header */\n.wb-board-meta {\n  padding: 14px 16px;\n  border-bottom: 1px solid var(--border-color, #e4e4e7);\n  flex-shrink: 0;\n}\n.wb-board-meta-name {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text-primary, #18181b);\n  margin: 0 0 6px 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.wb-board-color-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n.wb-board-meta-stats {\n  display: flex;\n  gap: 12px;\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n}\n.wb-board-meta-stat {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n.wb-board-delete-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  margin-top: 10px;\n  padding: 4px 10px;\n  border-radius: 5px;\n  border: 1px solid rgba(239,68,68,0.3);\n  background: none;\n  color: #ef4444;\n  font-size: 0.75rem;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n.wb-board-delete-btn:hover {\n  background: rgba(239,68,68,0.08);\n  border-color: #ef4444;\n}\n\n/* Sidebar section title */\n.wb-sidebar-section {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n.wb-sidebar-section + .wb-sidebar-section {\n  border-top: 1px solid var(--border-color, #e4e4e7);\n}\n.wb-sidebar-section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 16px;\n  flex-shrink: 0;\n}\n.wb-sidebar-section-title {\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--text-secondary);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.wb-sidebar-section-count {\n  font-size: 0.7rem;\n  background: var(--bg-tertiary, #f4f4f5);\n  padding: 1px 7px;\n  border-radius: 99px;\n  color: var(--text-secondary);\n}\n\n/* Connection filter */\n.wb-conn-filter-row {\n  display: flex;\n  gap: 4px;\n  padding: 0 12px 10px;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n}\n.wb-conn-filter-btn {\n  padding: 3px 9px;\n  border-radius: 99px;\n  border: 1px solid var(--border-color, #e4e4e7);\n  background: none;\n  font-size: 0.7rem;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.15s;\n}\n.wb-conn-filter-btn.active {\n  background: var(--accent, #2563eb);\n  border-color: var(--accent, #2563eb);\n  color: #fff;\n}\n\n/* Scrollable list areas */\n.wb-sidebar-list {\n  overflow-y: auto;\n  flex: 1;\n  padding: 4px 8px 12px;\n}\n\n/* Connection row */\n.wb-conn-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 8px;\n  border-radius: 7px;\n  cursor: default;\n  transition: background 0.13s;\n}\n.wb-conn-row:hover { background: var(--bg-tertiary, #f4f4f5); }\n.wb-conn-type-chip {\n  display: inline-block;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 0.62rem;\n  font-weight: 700;\n  color: #fff;\n  white-space: nowrap;\n  flex-shrink: 0;\n  text-transform: uppercase;\n}\n.wb-conn-names {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n.wb-conn-label {\n  font-size: 0.78rem;\n  color: var(--text-primary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.wb-conn-pair {\n  font-size: 0.7rem;\n  color: var(--text-secondary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.wb-conn-confidence {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 3px;\n  flex-shrink: 0;\n}\n.wb-conf-bar {\n  width: 40px;\n  height: 3px;\n  background: var(--border-color, #e4e4e7);\n  border-radius: 2px;\n  overflow: hidden;\n}\n.wb-conf-fill { height: 100%; border-radius: 2px; }\n.wb-conf-high { background: #10b981; }\n.wb-conf-mid  { background: #f59e0b; }\n.wb-conf-low  { background: #94a3b8; }\n.wb-conf-label {\n  font-size: 0.65rem;\n  color: var(--text-secondary);\n  font-weight: 600;\n}\n.wb-conn-dismiss-btn {\n  background: none;\n  border: none;\n  color: var(--text-secondary);\n  cursor: pointer;\n  padding: 3px 5px;\n  border-radius: 4px;\n  font-size: 0.72rem;\n  opacity: 0.5;\n  transition: opacity 0.15s, color 0.15s;\n  flex-shrink: 0;\n}\n.wb-conn-row:hover .wb-conn-dismiss-btn { opacity: 1; }\n.wb-conn-dismiss-btn:hover { color: #ef4444; }\n\n/* Item row in sidebar */\n.wb-item-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 8px;\n  border-radius: 7px;\n  cursor: pointer;\n  transition: background 0.13s;\n}\n.wb-item-row:hover { background: var(--bg-tertiary, #f4f4f5); }\n.wb-item-row.selected { background: rgba(37,99,235,0.08); }\n.wb-item-type-chip {\n  display: inline-block;\n  padding: 2px 7px;\n  border-radius: 4px;\n  font-size: 0.62rem;\n  font-weight: 700;\n  color: #fff;\n  white-space: nowrap;\n  flex-shrink: 0;\n  text-transform: uppercase;\n}\n.wb-item-title {\n  flex: 1;\n  font-size: 0.82rem;\n  color: var(--text-primary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.wb-item-remove-btn {\n  background: none;\n  border: none;\n  color: var(--text-secondary);\n  cursor: pointer;\n  padding: 3px 5px;\n  border-radius: 4px;\n  font-size: 0.72rem;\n  opacity: 0;\n  transition: opacity 0.15s, color 0.15s;\n  flex-shrink: 0;\n}\n.wb-item-row:hover .wb-item-remove-btn { opacity: 1; }\n.wb-item-remove-btn:hover { color: #ef4444; }\n\n/* ── Canvas area ──────────────────────────────────────────────────────────────── */\n.wb-canvas-wrap {\n  position: relative;\n  height: 100%;\n  min-height: 500px;\n  background: var(--bg-primary, #f4f4f5);\n  overflow: hidden;\n}\n\n/* React Flow full coverage */\n.wb-canvas-wrap .react-flow,\n.wb-canvas-wrap .react-flow__renderer,\n.wb-canvas-wrap .react-flow__container {\n  width: 100%;\n  height: 100%;\n}\n\n/* ── Empty / Loading / Error states ──────────────────────────────────────────── */\n.wb-state-center {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  gap: 14px;\n  color: var(--text-secondary);\n  padding: 48px;\n  text-align: center;\n}\n.wb-state-icon {\n  font-size: 3rem;\n  opacity: 0.35;\n}\n.wb-state-center h3 {\n  margin: 0;\n  font-size: 1.05rem;\n  color: var(--text-primary);\n  font-weight: 600;\n}\n.wb-state-center p {\n  margin: 0;\n  font-size: 0.88rem;\n  max-width: 360px;\n  line-height: 1.6;\n}\n.wb-spinner {\n  width: 36px;\n  height: 36px;\n  border: 3px solid var(--border-color, #e4e4e7);\n  border-top-color: var(--accent, #2563eb);\n  border-radius: 50%;\n  animation: wb-spin 1s linear infinite;\n}\n@keyframes wb-spin { to { transform: rotate(360deg); } }\n\n/* Empty canvas overlay */\n.wb-canvas-empty-overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  color: var(--text-secondary);\n  pointer-events: none;\n}\n.wb-canvas-empty-overlay i { font-size: 3rem; opacity: 0.2; }\n.wb-canvas-empty-overlay p { font-size: 0.9rem; opacity: 0.5; margin: 0; }\n\n/* No boards state */\n.wb-no-boards {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  gap: 16px;\n  color: var(--text-secondary);\n  padding: 48px;\n  text-align: center;\n}\n.wb-no-boards i { font-size: 4rem; opacity: 0.25; }\n.wb-no-boards h3 { margin: 0; font-size: 1.1rem; color: var(--text-primary); }\n.wb-no-boards p { margin: 0; font-size: 0.9rem; max-width: 340px; line-height: 1.6; }\n.wb-create-first-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  background: var(--accent, #2563eb);\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity 0.15s;\n}\n.wb-create-first-btn:hover { opacity: 0.87; }\n\n/* ── Item Detail Drawer ──────────────────────────────────────────────────────── */\n.wb-item-drawer {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: min(340px, 100%);\n  height: 100%;\n  background: var(--bg-secondary, #fff);\n  border-left: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 0 0 0 0;\n  overflow-y: auto;\n  z-index: 20;\n  display: flex;\n  flex-direction: column;\n  box-shadow: -4px 0 20px rgba(0,0,0,0.09);\n  animation: wb-drawer-in 0.18s ease;\n}\n@keyframes wb-drawer-in {\n  from { transform: translateX(30px); opacity: 0; }\n  to   { transform: translateX(0);    opacity: 1; }\n}\n\n.wb-drawer-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 16px;\n  border-bottom: 1px solid var(--border-color, #e4e4e7);\n  flex-shrink: 0;\n}\n.wb-drawer-title-block { flex: 1; min-width: 0; }\n.wb-drawer-type-chip {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 0.65rem;\n  font-weight: 700;\n  color: #fff;\n  text-transform: uppercase;\n  margin-bottom: 6px;\n}\n.wb-drawer-title {\n  margin: 0;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  line-height: 1.35;\n  word-break: break-word;\n}\n.wb-drawer-close-btn {\n  background: none;\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 6px;\n  padding: 5px 9px;\n  cursor: pointer;\n  color: var(--text-secondary);\n  font-size: 0.85rem;\n  flex-shrink: 0;\n  transition: all 0.15s;\n}\n.wb-drawer-close-btn:hover { background: #ef4444; color: #fff; border-color: #ef4444; }\n\n.wb-drawer-section {\n  padding: 14px 16px;\n  border-bottom: 1px solid var(--border-color, #e4e4e7);\n}\n.wb-drawer-section:last-child { border-bottom: none; }\n.wb-drawer-section-label {\n  font-size: 0.7rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--text-secondary);\n  margin: 0 0 8px 0;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n/* Tags */\n.wb-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n}\n.wb-tag {\n  background: rgba(37,99,235,0.09);\n  color: var(--accent, #2563eb);\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n/* Content / annotation */\n.wb-drawer-content-text {\n  font-size: 0.85rem;\n  color: var(--text-primary);\n  line-height: 1.6;\n  margin: 0;\n  white-space: pre-wrap;\n}\n\n/* Metadata table */\n.wb-meta-table {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n.wb-meta-row {\n  display: flex;\n  gap: 8px;\n  font-size: 0.8rem;\n  align-items: flex-start;\n}\n.wb-meta-key {\n  color: var(--text-secondary);\n  font-weight: 600;\n  min-width: 80px;\n  flex-shrink: 0;\n  padding-top: 2px;\n}\n.wb-meta-val {\n  color: var(--text-primary);\n  word-break: break-word;\n  flex: 1;\n}\n\n/* Null / empty value */\n.wb-meta-null {\n  color: var(--text-secondary);\n  font-style: italic;\n  opacity: 0.65;\n}\n\n/* Boolean badge */\n.wb-meta-bool {\n  display: inline-block;\n  padding: 1px 8px;\n  border-radius: 4px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n.wb-meta-bool-yes { background: rgba(16,185,129,0.15); color: #15803d; }\n.wb-meta-bool-no  { background: rgba(148,163,184,0.2);  color: #64748b; }\n\n/* Array of primitives — pill list */\n.wb-meta-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  flex: 1;\n}\n.wb-meta-tag {\n  display: inline-block;\n  padding: 2px 7px;\n  background: var(--bg-tertiary, #f4f4f5);\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 4px;\n  font-size: 0.75rem;\n  color: var(--text-primary);\n}\n\n/* Flat object — nested key-value sub-table */\n.wb-meta-sub-table {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  flex: 1;\n  background: var(--bg-tertiary, #f4f4f5);\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 5px;\n  padding: 6px 8px;\n}\n.wb-meta-sub-row {\n  display: flex;\n  gap: 6px;\n  font-size: 0.75rem;\n}\n.wb-meta-sub-key {\n  color: var(--text-secondary);\n  font-weight: 600;\n  min-width: 70px;\n  flex-shrink: 0;\n}\n.wb-meta-sub-val {\n  color: var(--text-primary);\n  word-break: break-word;\n  flex: 1;\n}\n\n/* Complex / nested object — formatted JSON block */\n.wb-meta-json {\n  flex: 1;\n  margin: 0;\n  padding: 7px 10px;\n  background: var(--bg-tertiary, #f4f4f5);\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 5px;\n  font-family: ui-monospace, 'Cascadia Code', monospace;\n  font-size: 0.72rem;\n  color: var(--text-secondary);\n  white-space: pre-wrap;\n  word-break: break-word;\n  overflow-x: auto;\n  line-height: 1.55;\n  max-height: 180px;\n}\n\n/* Connections in drawer */\n.wb-drawer-conn-row {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  padding: 5px 0;\n  border-bottom: 1px solid var(--border-color, #f4f4f5);\n  font-size: 0.8rem;\n}\n.wb-drawer-conn-row:last-child { border-bottom: none; }\n.wb-drawer-conn-name { flex: 1; color: var(--text-primary); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.wb-drawer-conf {\n  font-size: 0.7rem;\n  font-weight: 600;\n  padding: 1px 5px;\n  border-radius: 4px;\n  white-space: nowrap;\n}\n\n/* ── Confirm dialog overlay ─────────────────────────────────────────────────── */\n.wb-confirm-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.45);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.wb-confirm-box {\n  background: var(--bg-secondary, #fff);\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 12px;\n  padding: 28px 32px;\n  max-width: 380px;\n  width: 90%;\n  box-shadow: 0 20px 60px rgba(0,0,0,0.2);\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.wb-confirm-box h4 {\n  margin: 0;\n  font-size: 1rem;\n  color: var(--text-primary);\n}\n.wb-confirm-box p {\n  margin: 0;\n  font-size: 0.88rem;\n  color: var(--text-secondary);\n  line-height: 1.55;\n}\n.wb-confirm-actions {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n}\n.wb-confirm-cancel-btn {\n  padding: 8px 16px;\n  border-radius: 7px;\n  border: 1px solid var(--border-color, #e4e4e7);\n  background: none;\n  color: var(--text-secondary);\n  font-size: 0.88rem;\n  cursor: pointer;\n}\n.wb-confirm-delete-btn {\n  padding: 8px 16px;\n  border-radius: 7px;\n  border: none;\n  background: #ef4444;\n  color: #fff;\n  font-size: 0.88rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity 0.15s;\n}\n.wb-confirm-delete-btn:hover { opacity: 0.87; }\n\n/* ── Toast notification ─────────────────────────────────────────────────────── */\n.wb-toast {\n  position: fixed;\n  bottom: 24px;\n  right: 24px;\n  background: #1e293b;\n  color: #fff;\n  padding: 10px 18px;\n  border-radius: 8px;\n  font-size: 0.85rem;\n  box-shadow: 0 8px 24px rgba(0,0,0,0.25);\n  z-index: 2000;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  animation: wb-toast-in 0.2s ease;\n}\n.wb-toast.success { background: #15803d; }\n.wb-toast.error   { background: #b91c1c; }\n@keyframes wb-toast-in {\n  from { transform: translateY(12px); opacity: 0; }\n  to   { transform: translateY(0);    opacity: 1; }\n}\n\n/* ── Board Insights Panel (.wb-insights-*) ──────────────────────────────────── */\n.wb-insights-panel {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: min(460px, 100%);\n  height: 100%;\n  background: var(--bg-secondary, #fff);\n  border-left: 1px solid var(--border-color, #e4e4e7);\n  overflow-y: auto;\n  z-index: 25;\n  display: flex;\n  flex-direction: column;\n  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.12);\n  animation: wb-drawer-in 0.18s ease;\n}\n\n.wb-insights-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 16px;\n  border-bottom: 1px solid var(--border-color, #e4e4e7);\n  flex-shrink: 0;\n  background: linear-gradient(135deg, rgba(37, 99, 235, 0.05) 0%, rgba(99, 102, 241, 0.05) 100%);\n}\n.wb-insights-brain-icon {\n  font-size: 1.4rem;\n  color: var(--accent, #2563eb);\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n.wb-insights-header-left {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  flex: 1;\n  min-width: 0;\n}\n.wb-insights-title {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text-primary, #18181b);\n}\n.wb-insights-timestamp {\n  display: block;\n  font-size: 0.72rem;\n  color: var(--text-secondary, #71717a);\n  margin-top: 3px;\n}\n.wb-insights-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n}\n.wb-insights-regen-btn {\n  background: none;\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 6px;\n  padding: 5px 9px;\n  cursor: pointer;\n  color: var(--text-secondary, #71717a);\n  font-size: 0.8rem;\n  transition: all 0.15s;\n}\n.wb-insights-regen-btn:hover:not(:disabled) { border-color: var(--accent, #2563eb); color: var(--accent, #2563eb); }\n.wb-insights-regen-btn:disabled { opacity: 0.5; cursor: not-allowed; }\n.wb-insights-close-btn {\n  background: none;\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 6px;\n  padding: 5px 9px;\n  cursor: pointer;\n  color: var(--text-secondary, #71717a);\n  font-size: 0.85rem;\n  transition: all 0.15s;\n}\n.wb-insights-close-btn:hover { background: #ef4444; color: #fff; border-color: #ef4444; }\n\n.wb-insights-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  flex: 1;\n  color: var(--text-secondary, #71717a);\n  padding: 48px;\n  text-align: center;\n}\n.wb-insights-loading p { margin: 0; font-size: 0.9rem; }\n\n.wb-insights-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  flex: 1;\n  padding: 40px;\n  color: #dc2626;\n  text-align: center;\n}\n.wb-insights-error i { font-size: 2rem; opacity: 0.7; }\n.wb-insights-error p { margin: 0; font-size: 0.88rem; }\n.wb-insights-error button {\n  padding: 7px 16px;\n  border-radius: 6px;\n  border: 1px solid rgba(239, 68, 68, 0.4);\n  background: none;\n  color: #dc2626;\n  font-size: 0.85rem;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n.wb-insights-error button:hover { background: rgba(239, 68, 68, 0.08); }\n\n.wb-insights-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  background: var(--bg-primary, #f4f4f5);\n}\n\n.wb-insights-section {\n  background: var(--bg-secondary, #fff);\n  border: 1px solid var(--border-color, #e4e4e7);\n  border-radius: 10px;\n  padding: 14px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.wb-insights-section-title {\n  margin: 0;\n  font-size: 0.78rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--text-secondary, #71717a);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid var(--border-color, #e4e4e7);\n}\n.wb-insights-section-title i { color: var(--accent, #2563eb); }\n\n.wb-insights-overview {\n  margin: 0;\n  font-size: 0.875rem;\n  color: var(--text-primary, #18181b);\n  line-height: 1.65;\n  font-style: italic;\n}\n\n.wb-insights-group { display: flex; flex-direction: column; gap: 6px; }\n.wb-insights-group-label {\n  margin: 0;\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  color: var(--text-secondary, #71717a);\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.wb-insights-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n.wb-insights-list-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  font-size: 0.83rem;\n  color: var(--text-primary, #18181b);\n  line-height: 1.5;\n  padding: 6px 10px;\n  border-radius: 5px;\n}\n.wb-insights-list-item::before {\n  content: '';\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  background: var(--border-color, #e4e4e7);\n  flex-shrink: 0;\n  margin-top: 5px;\n}\n.wb-insights-theme          { background: rgba(37, 99, 235, 0.05);  }\n.wb-insights-theme::before  { background: var(--accent, #2563eb); }\n.wb-insights-signal         { background: rgba(8, 145, 178, 0.05); }\n.wb-insights-signal::before { background: #0891b2; }\n.wb-insights-anomaly        { background: rgba(245, 158, 11, 0.07); }\n.wb-insights-anomaly::before{ background: #f59e0b; }\n.wb-insights-relationship        { background: rgba(99, 102, 241, 0.05); }\n.wb-insights-relationship::before{ background: #6366f1; }\n.wb-insights-hub            { background: rgba(245, 158, 11, 0.05); }\n.wb-insights-hub::before    { background: #f59e0b; }\n.wb-insights-lead           { background: rgba(16, 185, 129, 0.05); }\n.wb-insights-lead::before   { background: #10b981; }\n\n.wb-insights-recommendation {\n  background: rgba(37, 99, 235, 0.05);\n  border: 1px solid rgba(37, 99, 235, 0.12);\n  padding: 8px 10px;\n  gap: 10px;\n}\n.wb-insights-recommendation::before { display: none; }\n.wb-insights-rec-num {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  min-width: 20px;\n  background: var(--accent, #2563eb);\n  color: #fff;\n  border-radius: 50%;\n  font-size: 0.65rem;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.wb-insights-footer-row {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  padding-top: 4px;\n}\n.wb-insights-footer-meta {\n  margin: 0;\n  font-size: 0.72rem;\n  color: var(--text-secondary, #71717a);\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  opacity: 0.65;\n}\n\n/* Insights button active state */\n.wb-board-action-btn.wb-insights-btn.active {\n  background: rgba(37, 99, 235, 0.08);\n  border-color: var(--accent, #2563eb);\n  color: var(--accent, #2563eb);\n}\n.wb-board-action-btn.wb-insights-btn:hover:not(:disabled) {\n  background: var(--accent, #2563eb);\n  color: #fff;\n  border-color: var(--accent, #2563eb);\n}\n.wb-board-action-btn.wb-insights-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n/* ── Dark theme overrides ───────────────────────────────────────────────────── */\n[data-theme=\"dark\"] {\n  .wb-board-bar { background: var(--bg-secondary); }\n  .wb-board-tab { background: var(--bg-tertiary); }\n  .wb-board-tab:hover { background: var(--bg-secondary); }\n  .wb-board-action-btn { background: var(--bg-secondary); }\n  .wb-new-board-input { background: var(--bg-secondary); }\n  .wb-sidebar { background: var(--bg-secondary); }\n  .wb-item-drawer { background: var(--bg-secondary); box-shadow: -4px 0 20px rgba(0,0,0,0.45); }\n  .wb-conn-row:hover { background: var(--bg-tertiary); }\n  .wb-item-row:hover { background: var(--bg-tertiary); }\n  .wb-item-row.selected { background: rgba(59,130,246,0.12); }\n  .wb-confirm-overlay { background: rgba(0,0,0,0.65); }\n  .wb-confirm-box { background: var(--bg-secondary); box-shadow: 0 20px 60px rgba(0,0,0,0.6); }\n  .wb-toast { background: #334155; }\n  .wb-toast.success { background: #166534; }\n  .wb-toast.error   { background: #991b1b; }\n  .wb-insights-panel { box-shadow: -4px 0 24px rgba(0,0,0,.5); }\n  .wb-insights-header { background: linear-gradient(135deg, rgba(37,99,235,.1) 0%, rgba(99,102,241,.1) 100%); }\n  .wb-insights-body { background: var(--bg-primary); }\n  .wb-insights-section { background: var(--bg-secondary); border-color: var(--border-color); }\n  .wb-insights-section-title { border-bottom-color: var(--border-color); }\n}\n\n/* ═══════════════════════════════════════════════════════════════════════════\n   PIN TO BOARD POPOVER\n   ═══════════════════════════════════════════════════════════════════════════ */\n\n.wb-pin-popover {\n  width: 272px;\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 12px;\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.18), 0 2px 8px rgba(0, 0, 0, 0.08);\n  overflow: hidden;\n  font-family: inherit;\n  animation: wb-pin-in 0.14s ease-out;\n}\n\n@keyframes wb-pin-in {\n  from { opacity: 0; transform: translateY(-4px) scale(0.97); }\n  to   { opacity: 1; transform: translateY(0)    scale(1); }\n}\n\n/* Header */\n.wb-pin-popover-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 11px 14px 10px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.07);\n  background: #f8fafc;\n}\n\n.wb-pin-icon {\n  color: #f59e0b;\n  font-size: 0.85rem;\n  flex-shrink: 0;\n}\n\n.wb-pin-popover-label {\n  flex: 1;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #1e293b;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.wb-pin-popover-close {\n  background: none;\n  border: none;\n  color: #94a3b8;\n  cursor: pointer;\n  padding: 2px 4px;\n  border-radius: 4px;\n  font-size: 0.78rem;\n  line-height: 1;\n  flex-shrink: 0;\n  transition: color 0.15s, background 0.15s;\n}\n.wb-pin-popover-close:hover { color: #475569; background: rgba(0,0,0,0.06); }\n\n/* Feedback bar */\n.wb-pin-feedback {\n  font-size: 0.78rem;\n  font-weight: 500;\n  padding: 7px 14px;\n  text-align: center;\n}\n.wb-pin-feedback-success { background: rgba(16,185,129,0.1); color: #065f46; }\n.wb-pin-feedback-warn    { background: rgba(245,158,11,0.1);  color: #92400e; }\n.wb-pin-feedback-error   { background: rgba(239,68,68,0.1);   color: #991b1b; }\n\n/* Board list */\n.wb-pin-board-list {\n  max-height: 220px;\n  overflow-y: auto;\n  padding: 4px 0;\n}\n\n.wb-pin-no-boards {\n  font-size: 0.78rem;\n  color: #94a3b8;\n  text-align: center;\n  padding: 16px 14px;\n  margin: 0;\n}\n\n.wb-pin-board-row {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  width: 100%;\n  padding: 8px 14px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  text-align: left;\n  transition: background 0.12s;\n}\n.wb-pin-board-row:hover:not(:disabled) { background: rgba(99,102,241,0.07); }\n.wb-pin-board-row:disabled { opacity: 0.55; cursor: not-allowed; }\n\n.wb-pin-board-dot {\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.wb-pin-board-name {\n  flex: 1;\n  font-size: 0.83rem;\n  font-weight: 500;\n  color: #1e293b;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.wb-pin-board-count {\n  font-size: 0.72rem;\n  color: #94a3b8;\n  background: #f1f5f9;\n  border-radius: 10px;\n  padding: 1px 7px;\n  flex-shrink: 0;\n}\n\n.wb-pin-board-spinner {\n  color: #6366f1;\n  font-size: 0.78rem;\n}\n\n/* Footer */\n.wb-pin-popover-footer {\n  border-top: 1px solid rgba(0,0,0,0.07);\n  padding: 8px 10px;\n  background: #f8fafc;\n}\n\n.wb-pin-new-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  padding: 7px 10px;\n  background: none;\n  border: 1.5px dashed #cbd5e1;\n  border-radius: 7px;\n  color: #64748b;\n  font-size: 0.8rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: border-color 0.15s, color 0.15s, background 0.15s;\n}\n.wb-pin-new-btn:hover { border-color: #6366f1; color: #6366f1; background: rgba(99,102,241,0.04); }\n\n.wb-pin-new-row {\n  display: flex;\n  gap: 6px;\n}\n\n.wb-pin-new-input {\n  flex: 1;\n  padding: 6px 10px;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 7px;\n  font-size: 0.8rem;\n  color: #1e293b;\n  background: #fff;\n  outline: none;\n  transition: border-color 0.15s;\n}\n.wb-pin-new-input:focus { border-color: #6366f1; }\n\n.wb-pin-new-confirm {\n  padding: 6px 11px;\n  background: #6366f1;\n  color: #fff;\n  border: none;\n  border-radius: 7px;\n  font-size: 0.78rem;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.15s;\n}\n.wb-pin-new-confirm:hover:not(:disabled) { background: #4f46e5; }\n.wb-pin-new-confirm:disabled { opacity: 0.55; cursor: not-allowed; }\n\n/* ═══════════════════════════════════════════════════════════════════════════\n   GENERIC PIN BUTTON — table rows (IntelligenceTable, NewsTable, PdfTable)\n   ═══════════════════════════════════════════════════════════════════════════ */\n\n.pin-btn {\n  background: none;\n  border: none;\n  color: #94a3b8;\n  cursor: pointer;\n  padding: 4px 6px;\n  border-radius: 5px;\n  font-size: 0.85rem;\n  line-height: 1;\n  transition: color 0.15s, background 0.15s;\n  vertical-align: middle;\n}\n.pin-btn:hover { color: #f59e0b; background: rgba(245,158,11,0.1); }\n\n.actions-cell {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  white-space: nowrap;\n}\n\n/* ═══════════════════════════════════════════════════════════════════════════\n   OS PIN BUTTON — OmniSearch NodeDetailSidebar\n   ═══════════════════════════════════════════════════════════════════════════ */\n\n.os-pin-btn {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  width: 100%;\n  padding: 9px 14px;\n  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 0.82rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity 0.15s, transform 0.12s;\n  letter-spacing: 0.01em;\n}\n.os-pin-btn:hover { opacity: 0.88; transform: translateY(-1px); }\n.os-pin-btn:active { transform: translateY(0); }\n.os-pin-btn i { font-size: 0.78rem; }\n\n/* Dark mode overrides for pin popover */\n@media (prefers-color-scheme: dark) {\n  .wb-pin-popover { background: #1e293b; border-color: rgba(255,255,255,0.1); }\n  .wb-pin-popover-header { background: #0f172a; border-bottom-color: rgba(255,255,255,0.07); }\n  .wb-pin-popover-label { color: #f1f5f9; }\n  .wb-pin-board-name { color: #e2e8f0; }\n  .wb-pin-board-count { background: #334155; color: #94a3b8; }\n  .wb-pin-popover-footer { background: #0f172a; border-top-color: rgba(255,255,255,0.07); }\n  .wb-pin-new-input { background: #1e293b; border-color: #334155; color: #f1f5f9; }\n  .wb-pin-board-row:hover:not(:disabled) { background: rgba(99,102,241,0.12); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
